import Shipment from '../../../types/api/shipment'

export type ToolingKind = 'stamp' | 'forms'

export function isShipmentToolingIncluded(shipment: Shipment, kind: ToolingKind): boolean {
    const flag = kind === 'stamp' ? shipment.stampIncludedInCost : shipment.formsIncludedInCost
    return flag !== false
}

export function canToggleShipmentTooling(shipment: Shipment, kind: ToolingKind): boolean {
    if (shipment.print_job || !shipment.order?.documentId) {
        return false
    }

    if (!isShipmentToolingIncluded(shipment, kind)) {
        return true
    }

    const cost =
        kind === 'stamp'
            ? Number(shipment.calculated?.stampCost ?? 0)
            : Number(shipment.calculated?.formsCost ?? 0)

    if (cost <= 0) {
        return false
    }

    if (kind === 'stamp' && !shipment.stamp?.documentId) {
        return false
    }

    return true
}
